import { render } from "./KostenVorschau.vue?vue&type=template&id=895dd1bc"
import script from "./KostenVorschau.vue?vue&type=script&lang=js"
export * from "./KostenVorschau.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__